/* eslint-disable no-underscore-dangle */

'use client';

import { useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/compat/router';
import { PortableText } from '@portabletext/react';
import Icon from '@/core/icon';
import {
 Markdown, lang, useTranslation, hocTranslateServerClient,
} from '@/helpers/translate';
import CardCms from '@/components/space/card-cms.js';
import { Search } from '@/core/dynamic';
import { getPathByLang } from '@/helpers/router';
import { useZusModalStore, ModalWrapper } from '@/helpers/modal.js';
import { useZusHomeStore } from '@/helpers/context';
import { useZusTrackerStore } from '@/helpers/tracker.js';
import { useZusUserConnectedStore } from '@/helpers/user-auth.js';
import CmsPaginator from '@/app/cms/paginator';

export default hocTranslateServerClient(({
 t, cmsContent, spacesData, getSpacesByTagscounting, perPage, currentPage,
}) => {
  const langCurrent = lang();
  const { query = {}, asPath } = useRouter() || {};
  const { setModal1 } = useZusModalStore.getState();
  const { extWebpJpg: extension } = useZusHomeStore.getState();
  const { setOrEvent } = useZusTrackerStore.getState();
  const [show, setShow] = useState(false);
  const logosRef = useRef(null);

  function openSearch() {
    setModal1(
      <ModalWrapper onClose={() => setModal1(null)} delay={1}>
        <Search isPopin />
      </ModalWrapper>,
    );
  }

  function renderLogoPartners() {
    const fnTab2 = (tabs) => tabs.map((i, index) => {
      const keylogopartner = (i || []).flat().join('');
      return (
        <div className={`relative flex items-center justify-center w-full h-20 ${index >= 9 ? 'hidden lg:flex' : ''}`} key={`other_homepage_logos_${keylogopartner}`}>
          {i.map((ii, iindex) => {
            const keylogopartner2 = keylogopartner + (ii || []).flat().join('');
            const newIIndex = iindex + 1;
            return (
              <img
                key={`other_homepage_logos_img${keylogopartner2}`}
                className={`${ii[2]}`}
                src={`/imgv4/logos-riders/${ii[0]}.svg`}
                alt={`Logo ${ii[1]}`}
              />
            );
          })}
        </div>
      );
    });

    return (
      <div className="grid justify-center w-full grid-cols-3 col-span-3 lg:grid-cols-10 gap-x-10 md:grid-cols-6" key="desktop_homepage_logos_1">
        {fnTab2([
          [['netflix', 'Netflix', 'max-w-16']],
          [['dior', 'Dior', 'max-w-14 max-h-8']],
          [['lepacte', 'Le Pacte', 'max-w-16 max-h-6']],
          [['canal', 'Canal+', 'max-w-16 max-h-10']],
          [['arte', 'Arte Tv', 'max-w-16 max-h-9']],
          [['deezer', 'Deezer', 'max-w-20 max-h-10']],
          [['brut', 'Brut', 'max-w-20 max-h-10']],
          [['kom', 'Kom', 'max-h-7']],
          [['chloe', 'Chloé', 'max-w-16 max-h-7']],
          [['webedia', 'Webedia', 'max-w-20 max-h-12']],
        ])}
      </div>
    );
  }

  useEffect(() => {
    setOrEvent('guide_classic');
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '50px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setShow(true);
          // Une fois que l'élément est visible, on arrête de l'observer
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    if (logosRef.current) {
      observer.observe(logosRef.current);
    }

    return () => {
      if (logosRef.current) {
        observer.unobserve(logosRef.current);
      }
    };
  }, []);

  const HomeComponentConnected = ({ children }) => {
    const userConnected = useZusUserConnectedStore((state) => state.userData);
    return children(userConnected);
  };

  return (
    <>
      <section className="h-min-[800px] lg:py-0 lg:min-h-[680px] flex items-center justify-center bg-purple-5 bg-gradient-to-t bg-[#403167] lg:bg-purple-5 lg:bg-[url('/img/bg-top-right.png')] bg-no-repeat bg-[position:100%_-0%] 2xl:bg-[position:100%_-10%] xl:bg-[size:1100px_auto] 2xl:bg-[size:1180px_auto]">
        <HomeComponentConnected>
          {(userConnected) => (
            <div className="flex flex-col items-center justify-center pb-20 text-center lg:pb-12 lg:py-0 z-5">
              <div className="flex items-center pt-20 lg:invisible lg:pt-0 lg:size-0">
                <div className="mb-3 size-11 lg:size-0">
                  <Icon name="logo-officeriders-min" className="size-11" />
                </div>
              </div>
              <h1 className={`z-5 inlirelative px-3.5 py-2 text-purple-3 lg:flex flex-col lg:flex-row justify-center items-center lg:gap-x-1 cursor-pointerne-block text-white text-xl lg:pt-32 md:text-2xl lg:text-5xl lg:max-w-2xl leading-6 lg:leading-tight font-medium px-6 ${!userConnected?.corpoUserConf?.requireValidEmail ? ' ' : 'lg:pt-6'} `}>
                {cmsContent.title}
              </h1>
              <h2 className="max-w-xl px-8 pt-1 pb-6 text-lg font-light leading-7 text-center lg:px-0 lg:pt-4 lg:pb-4 sm:text-xl lg:text-xl text-purple-3 lg:text-purple-4/90">
                {t('discovery:subtitle')}
              </h2>
              <Search
                isCms
                categoryDefault={cmsContent.category}
              />
              <div className="hidden grid-cols-3 px-6 pt-12 lg:grid lg:pt-24 gap-x-6 lg:gap-x-16 lg:px-0">
                <div className="flex flex-col items-center max-w-[200px] gap-x-2">
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.197 9.697C13.4899 9.4041 13.4899 8.92923 13.197 8.63634C12.9041 8.34344 12.4292 8.34344 12.1363 8.63634L13.197 9.697ZM6.303 14.4697C6.01011 14.7626 6.01011 15.2374 6.303 15.5303C6.5959 15.8232 7.07077 15.8232 7.36366 15.5303L6.303 14.4697ZM6.303 15.5303C6.5959 15.8232 7.07077 15.8232 7.36366 15.5303C7.65656 15.2374 7.65656 14.7626 7.36366 14.4697L6.303 15.5303ZM1.53033 8.63634C1.23744 8.34344 0.762563 8.34344 0.46967 8.63634C0.176777 8.92923 0.176777 9.4041 0.46967 9.697L1.53033 8.63634ZM6.08333 15C6.08333 15.4142 6.41912 15.75 6.83333 15.75C7.24755 15.75 7.58333 15.4142 7.58333 15H6.08333ZM7.58333 1C7.58333 0.585786 7.24755 0.25 6.83333 0.25C6.41912 0.25 6.08333 0.585786 6.08333 1H7.58333ZM12.1363 8.63634L6.303 14.4697L7.36366 15.5303L13.197 9.697L12.1363 8.63634ZM7.36366 14.4697L1.53033 8.63634L0.46967 9.697L6.303 15.5303L7.36366 14.4697ZM7.58333 15V1H6.08333V15H7.58333Z" fill="#865FFF" />
                  </svg>
                  <span className="mt-3 text-sm font-light text-purple-4">{t('discovery:features.places')}</span>
                </div>
                <div className="flex flex-col items-center max-w-[200px] gap-x-2">
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.197 9.697C13.4899 9.4041 13.4899 8.92923 13.197 8.63634C12.9041 8.34344 12.4292 8.34344 12.1363 8.63634L13.197 9.697ZM6.303 14.4697C6.01011 14.7626 6.01011 15.2374 6.303 15.5303C6.5959 15.8232 7.07077 15.8232 7.36366 15.5303L6.303 14.4697ZM6.303 15.5303C6.5959 15.8232 7.07077 15.8232 7.36366 15.5303C7.65656 15.2374 7.65656 14.7626 7.36366 14.4697L6.303 15.5303ZM1.53033 8.63634C1.23744 8.34344 0.762563 8.34344 0.46967 8.63634C0.176777 8.92923 0.176777 9.4041 0.46967 9.697L1.53033 8.63634ZM6.08333 15C6.08333 15.4142 6.41912 15.75 6.83333 15.75C7.24755 15.75 7.58333 15.4142 7.58333 15H6.08333ZM7.58333 1C7.58333 0.585786 7.24755 0.25 6.83333 0.25C6.41912 0.25 6.08333 0.585786 6.08333 1H7.58333ZM12.1363 8.63634L6.303 14.4697L7.36366 15.5303L13.197 9.697L12.1363 8.63634ZM7.36366 14.4697L1.53033 8.63634L0.46967 9.697L6.303 15.5303L7.36366 14.4697ZM7.58333 15V1H6.08333V15H7.58333Z" fill="#865FFF" />
                  </svg>
                  <span className="mt-3 text-sm font-light text-purple-4">{t('discovery:features.find')}</span>
                </div>
                <div className="flex flex-col items-center max-w-[200px] gap-x-2">
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.197 9.697C13.4899 9.4041 13.4899 8.92923 13.197 8.63634C12.9041 8.34344 12.4292 8.34344 12.1363 8.63634L13.197 9.697ZM6.303 14.4697C6.01011 14.7626 6.01011 15.2374 6.303 15.5303C6.5959 15.8232 7.07077 15.8232 7.36366 15.5303L6.303 14.4697ZM6.303 15.5303C6.5959 15.8232 7.07077 15.8232 7.36366 15.5303C7.65656 15.2374 7.65656 14.7626 7.36366 14.4697L6.303 15.5303ZM1.53033 8.63634C1.23744 8.34344 0.762563 8.34344 0.46967 8.63634C0.176777 8.92923 0.176777 9.4041 0.46967 9.697L1.53033 8.63634ZM6.08333 15C6.08333 15.4142 6.41912 15.75 6.83333 15.75C7.24755 15.75 7.58333 15.4142 7.58333 15H6.08333ZM7.58333 1C7.58333 0.585786 7.24755 0.25 6.83333 0.25C6.41912 0.25 6.08333 0.585786 6.08333 1H7.58333ZM12.1363 8.63634L6.303 14.4697L7.36366 15.5303L13.197 9.697L12.1363 8.63634ZM7.36366 14.4697L1.53033 8.63634L0.46967 9.697L6.303 15.5303L7.36366 14.4697ZM7.58333 15V1H6.08333V15H7.58333Z" fill="#865FFF" />
                  </svg>
                  <span className="mt-3 text-sm font-light text-purple-4">{t('discovery:features.exchange')}</span>
                </div>
              </div>
            </div>
          )}
        </HomeComponentConnected>
      </section>
      <section className="flex items-center px-10 mx-auto bg-purple-6 md:px-20 min-h-[120px]">
        <div
          ref={logosRef}
          className="container relative flex flex-col items-center justify-center w-full px-2 py-5 rounded-xl"
        >
          {!show ? null : <>{renderLogoPartners()}</>}
        </div>
      </section>
      <section>
        { currentPage > 1 || <>
        <div className="bg-purple-0 py-18 text-purple-5/80 text-[13px]">
          <section className="container px-8 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
            <div className="font-normal leading-relaxed column-guide">
              <PortableText value={cmsContent.part_0_desc} />
            </div>
          </section>
          <section className="container px-10 py-6 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
            <div className="font-normal leading-relaxed column-guide">
              <PortableText value={cmsContent.part_1_desc} />
            </div>
          </section>

          <section className="container px-10 py-6 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
            <div className="font-normal leading-relaxed column-guide">
              <PortableText value={cmsContent.part_2_desc} />
            </div>
          </section>
        </div>
                             </>}
      </section>
      { currentPage < 1 || <>
      <section className="bg-white py-14">
        <div className="container px-8 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
          <div className={`grid w-full grid-cols-1 mb-10 gap-x-8 gap-y-6 ${currentPage > 1 ? 'lg:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-2'}`}>
            <CardCms item={spacesData?.[0] || null} />
            <CardCms item={spacesData?.[1] || null} />
            {currentPage > 1 ? (
              <CardCms item={spacesData?.[8] || null} />
            ) : null}
          </div>
          <div className="grid w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
            <CardCms item={spacesData?.[2] || null} />
            <CardCms item={spacesData?.[3] || null} />
            <CardCms item={spacesData?.[4] || null} />
            <CardCms item={spacesData?.[5] || null} />
            <CardCms item={spacesData?.[6] || null} />
            <CardCms item={spacesData?.[7] || null} />
            {currentPage > 1 ? (
              <>
              <CardCms item={spacesData?.[9] || null} />
              <CardCms item={spacesData?.[10] || null} />
              <CardCms item={spacesData?.[11] || null} />
              <CardCms item={spacesData?.[12] || null} />
              <CardCms item={spacesData?.[13] || null} />
              <CardCms item={spacesData?.[14] || null} />
              <CardCms item={spacesData?.[15] || null} />
              <CardCms item={spacesData?.[16] || null} />
              <CardCms item={spacesData?.[17] || null} />
              <CardCms item={spacesData?.[18] || null} />
              <CardCms item={spacesData?.[19] || null} />
              <CardCms item={spacesData?.[20] || null} />
              
              </>
            ) : null}
          </div>
        </div>
        <div className="flex justify-center w-full pt-10">
          <CmsPaginator total={getSpacesByTagscounting} {...{ perPage }} />
        </div>
      </section>
                           </>}
      { currentPage > 1 || <>
      <div className="bg-purple-0 py-18 text-purple-5/80 text-[13px]">
        <section className="container px-8 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
          <div className="font-normal leading-relaxed column-guide">
            <PortableText value={cmsContent.part_0_desc} />
          </div>
        </section>
        <section className="container px-10 py-6 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
          <div className="font-normal leading-relaxed column-guide">
            <PortableText value={cmsContent.part_1_desc} />
          </div>
        </section>

        <section className="container px-10 py-6 mx-auto md:px-10 lg:px-10 xl:px-30 2xl:px-40">
          <div className="font-normal leading-relaxed column-guide">
            <PortableText value={cmsContent.part_2_desc} />
          </div>
        </section>
      </div>
                           </>}
    </>
  );
});
